<template>
  <div>
    <div class="ReportDetailPagePurchase" style="padding: 20px;width: 500px;background-color: #fafafa">
      <div style="font-size: 20px">
        <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
          <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/OcrIndicator' }">橙视迅结</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="font-size: 25px;margin-top: 15px;">
        <p>橙视迅结指标</p>
      </div>
      <div style="width: 100%; font-size: 25px">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="margin-top: 10px;width: 500px">
          <el-form-item label="文件">
            <el-select v-model="ruleForm.fileName" filterable remote placeholder="请选择文件" style="width: 400px">
              <el-option
                v-for="item in files"
                :key="item"
                :label="item"
                :value='item'>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button class="button" @click="down">下载</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import {getOcrIndicator} from "@/api/OcrIndicator";

export default {
  name: 'LoginManagerAccount',
  data() {
    return {
      ruleForm: {
        fileName: ''
      },
      files: [],
      token: ''
    }
  },
  mounted() {
    const supplierId = localStorage.getItem('supplierId');
    if (supplierId === '15900973961' || supplierId === '17898848378') {
      this.token = localStorage.getItem('token')
    } else {
      this.$router.replace({ path: '/Console' })
    }
    getOcrIndicator(this.token).then(res => {
      this.files = res.data
      if (res.data && res.data.length === 1) {
        this.ruleForm.fileName = res.data[0]
      }
    })
  },
  methods: {
    down() {
      window.location.href = 'https://img.orangev.cn/' + this.ruleForm.fileName;
    }
  }
}
</script>

<style scoped>

</style>
